module.exports = __webpack_public_path__ + "static/media/gryphon-house-business-centre.fe10d1cc.jpg";